var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      staticStyle: { "overflow-y": "hidden" },
      attrs: { persistent: "" },
      model: {
        value: _vm.dialogDetailUser,
        callback: function($$v) {
          _vm.dialogDetailUser = $$v
        },
        expression: "dialogDetailUser"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card",
            {
              staticStyle: { "box-shadow": "none !important" },
              attrs: { tile: "" }
            },
            [
              _c(
                "v-toolbar",
                {
                  staticStyle: { background: "#2562af !important" },
                  attrs: { card: "" }
                },
                [
                  _c(
                    "v-toolbar-title",
                    { staticClass: "white--text CSChatThai" },
                    [_vm._v("ข้อมูล")]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { dark: "", icon: "", flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.closeDialog()
                        }
                      }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: {
                            color: "white !important",
                            "font-size": "20px !important"
                          }
                        },
                        [_vm._v("clear")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticStyle: { "max-height": "80vh", overflow: "scroll" } },
            [
              _c(
                "v-avatar",
                { staticClass: "profileBG_White", attrs: { size: "100" } },
                [
                  _vm.UserDetail_who.profile_picture
                    ? _c("img", {
                        staticClass: "alligator-turtle",
                        attrs: {
                          src: _vm.backends + _vm.UserDetail_who.profile_picture
                        }
                      })
                    : _c("span", { staticClass: "headline " }, [
                        _vm._v(
                          _vm._s(
                            _vm.UserDetail_who.display_name
                              ? _vm.UserDetail_who.display_name.length.charAt(0)
                              : ""
                          )
                        )
                      ])
                ]
              ),
              _vm._v(" "),
              _c("div", [
                _c(
                  "p",
                  {
                    staticClass: "HeadersDetail",
                    staticStyle: { "margin-top": "25px" }
                  },
                  [_vm._v("ชื่อ")]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "Detail" }, [
                  _vm._v(_vm._s(_vm.UserDetail_who.display_name) + " ")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { "margin-top": "20px" } }, [
                _c("p", { staticClass: "HeadersDetail" }, [_vm._v("อีเมล")]),
                _vm._v(" "),
                _c("p", { staticClass: "Detail" }, [
                  _vm._v(_vm._s(_vm.UserDetail_who.email) + " ")
                ])
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "btnSave",
                  attrs: { small: "" },
                  on: {
                    click: function($event) {
                      return _vm.selectRoom_userOnline()
                    }
                  }
                },
                [_vm._v("แชท")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62cdca53", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62cdca53","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mail/Detail/detail_user.vue
// module id = null
// module chunks = 